<div class="card flex justify-content-center">
  <p-sidebar [(visible)]="sidebarVisible" (onHide)="onClose()" [dismissible]="false" [blockScroll]="true" [fullScreen]="true">
    <ng-template pTemplate="header">
      <h2>
        <div *ngIf="isAdd; then addHeader; else editHeader"></div>
        <ng-template #addHeader>Add</ng-template>
        <ng-template #editHeader>Edit</ng-template>
        Announcement
      </h2>
    </ng-template>

    <ng-template pTemplate="content">
      <div class="p-fluid content-container">
        <p-floatLabel>
          <input id="title" type="text" pInputText [(ngModel)]="title" />
          <label for="title"><span style="color: red; font-size: larger">*</span> Announcement Title</label>
        </p-floatLabel>
        <app-rich-text-editor [content]="content" (contentChange)="onContentChange($event)"></app-rich-text-editor>
      </div>
    </ng-template>

    <ng-template pTemplate="footer">
      <!-- <p class="error-text">{{ errorMsg }}</p> -->
      <div class="footer-container">
        <button
          pButton
          pRipple
          label="Cancel"
          (click)="onClose()"
          class="cancel-button"
          styleClass="p-button-secondary"
          [disabled]="isSaving"
        ></button>
        <button pButton pRipple label="Save" (click)="onSaveAnnouncement()" [disabled]="!isValid" class="save-button"></button>
      </div>
    </ng-template>
  </p-sidebar>
</div>
